import * as $ from 'jquery'

// Mobile Menu
const $mobileMenuButton = $('.js-mobileMenuButton')
const $mobileMenu = $('.js-mobileMenu')
const $mobileMenuWrapper = $('.js-mobileMenuWrapper')
const $mobileMenuFocus = $('.js-mm-visible')
const $header = $('.site__header')


$mobileMenuButton.on('click', function() {
    if ($mobileMenuButton.hasClass('is-active')) {
        $mobileMenuButton.removeClass('is-active')

        $mobileMenu.css('height', 0)
        $mobileMenu.removeAttr('style')
        $mobileMenuFocus.attr('tabindex', -1)
        
    } else {
        // wrapper not scrolling at mobile with this code, 
        // const mobileMenuWrapperHeight = $mobileMenuWrapper.outerHeight()
        // $mobileMenuButton.addClass('is-active')

        // $mobileMenu.css('height', mobileMenuWrapperHeight)

        const vh = window.innerHeight
        const mobileMenuWrapperHeight = vh - 100
        
        $mobileMenuButton.addClass('is-active')
        $mobileMenuFocus.attr('tabindex', 0)

        $mobileMenu.css('height', mobileMenuWrapperHeight)

        // Close menu when escape key is pressed
        $($header).on('keydown', function(e) {
            if(e.key === 'Escape') {
                $mobileMenuButton.removeClass('is-active')

                $mobileMenu.css('height', 0)
                $mobileMenu.removeAttr('style')
                $mobileMenuFocus.attr('tabindex', -1)
                $mobileMenuButton.focus();
            }
        })  
    }
})

// Turning off mobile menu focus states when not visible
jQuery(function() {
    if(window.innerWidth >= 1080) {
        $mobileMenuFocus.attr('tabindex', -1)
}})

$(window).on('resize', function() {
    if(window.innerWidth >= 1080) {
        $mobileMenuFocus.attr('tabindex', -1)
}});

// Submenus
const $submenuButtons = $('.js-submenuButton')
const $mobileSubMenuFocus = $('.js-sm-visible')


$submenuButtons.on('click', function() {
    const $this = $(this)
    const submenuID = $this.data('submenu')
    const $associatedSubmenu = $(`.js-submenu[data-submenu="${submenuID}"]`)
    const $associatedSubmenuWrapper = $associatedSubmenu.find('.js-submenuWrapper')
    const $associatedSubmenuFocus = $associatedSubmenu.find($mobileSubMenuFocus)
    // Search for focusable elements within submenu

    if ($this.hasClass('-open')) {
        $this.removeClass('-open')

        $associatedSubmenu.css('height', 0)
        $associatedSubmenu.removeAttr('style')
        $associatedSubmenuFocus.attr('tabindex', -1)
    } else {
        const associatedSubmenuWrapperHeight = $associatedSubmenuWrapper.outerHeight()

        $this.addClass('-open')
        $associatedSubmenu.css('height', associatedSubmenuWrapperHeight)
        $associatedSubmenuFocus.attr('tabindex', 0)

        // Close submenus when escape key is pressed
        $($header).on('keydown', function(e) {
            if(e.key === 'Escape') {
                $this.removeClass('-open')

                $associatedSubmenu.css('height', 0)
                $associatedSubmenu.removeAttr('style')
                $associatedSubmenuFocus.attr('tabindex', -1)
            }
        })  
    }
})